import { API_BASE } from "./api.js";

function loadImage(url) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.crossOrigin = "anonymous";
    image.onload = () => resolve(image);
    image.onerror = reject;
    image.src = `${API_BASE}/v1/media/tmdb?url=${encodeURIComponent(url)}`;
  });
}

function cover(context, image, width, height) {
  const scale = Math.max(width / image.width, height / image.height);
  const drawnWidth = image.width * scale;
  const drawnHeight = image.height * scale;
  context.drawImage(image, (width - drawnWidth) / 2, (height - drawnHeight) / 2, drawnWidth, drawnHeight);
}

function wrappedLines(context, text, maximumWidth, maximumLines) {
  const words = String(text || "").split(/\s+/);
  const lines = [];
  let current = "";
  for (const word of words) {
    const candidate = current ? `${current} ${word}` : word;
    if (context.measureText(candidate).width <= maximumWidth) current = candidate;
    else { if (current) lines.push(current); current = word; }
    if (lines.length === maximumLines) break;
  }
  if (current && lines.length < maximumLines) lines.push(current);
  if (words.length && lines.length === maximumLines) lines[maximumLines - 1] = `${lines[maximumLines - 1].replace(/[.…]+$/, "")}…`;
  return lines;
}

export async function shareReviewImage(review) {
  const canvas = document.createElement("canvas");
  canvas.width = 1080; canvas.height = 1920;
  const context = canvas.getContext("2d");
  const gradient = context.createLinearGradient(0, 0, 1080, 1920);
  gradient.addColorStop(0, "#06130e"); gradient.addColorStop(1, "#010403");
  context.fillStyle = gradient; context.fillRect(0, 0, 1080, 1920);

  let poster = null;
  try { if (review.movie.posterURL) poster = await loadImage(review.movie.posterURL); } catch { /* branded fallback */ }
  if (poster) {
    context.save(); context.globalAlpha = .22; context.filter = "blur(38px) saturate(.75)"; cover(context, poster, 1080, 1920); context.restore();
    context.fillStyle = "rgba(0,8,5,.68)"; context.fillRect(0, 0, 1080, 1920);
    context.save(); context.shadowColor = "rgba(0,0,0,.65)"; context.shadowBlur = 45;
    context.beginPath(); context.roundRect(325, 150, 430, 645, 30); context.clip(); context.drawImage(poster, 325, 150, 430, 645); context.restore();
  }
  context.fillStyle = "#f5f4ed"; context.textAlign = "center"; context.font = "700 58px sans-serif";
  wrappedLines(context, `${review.movie.title}${review.movie.year ? ` · ${review.movie.year}` : ""}`, 900, 2).forEach((line, index) => context.fillText(line, 540, 910 + index * 68));
  context.fillStyle = "#26d6a4"; context.font = "62px sans-serif"; context.fillText(`${"★".repeat(Math.floor(review.rating || 0))}${review.rating % 1 ? "½" : ""}`, 540, 1080);
  context.fillStyle = "#f5f4ed"; context.font = "42px sans-serif";
  wrappedLines(context, review.text || "Sin texto.", 820, 7).forEach((line, index) => context.fillText(line, 540, 1210 + index * 58));
  context.fillStyle = "#a6aea9"; context.font = "32px sans-serif"; context.fillText(`@${review.user.username}`, 540, 1710);
  context.fillStyle = "#26d6a4"; context.font = "700 42px sans-serif"; context.fillText("ROLLO", 540, 1800);

  const blob = await new Promise((resolve, reject) => canvas.toBlob((value) => value ? resolve(value) : reject(new Error("No se ha podido crear la imagen.")), "image/png"));
  const file = new File([blob], `rollo-${review.movie.id}.png`, { type: "image/png" });
  if (navigator.share && navigator.canShare?.({ files: [file] })) {
    await navigator.share({ title: `Reseña de ${review.movie.title}`, files: [file] });
    return;
  }
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob); link.download = file.name; link.click();
  setTimeout(() => URL.revokeObjectURL(link.href), 1000);
}
